module.exports = __webpack_public_path__ + "static/main8-en-1d66a9f3d9bb1e54d96ce87bd32b4955.png";